export default class CitiesObject {
  constructor() {
    this.cities = [{
      // IT.29TV8TPSSTDV4
      name: 'Singapore',
      city_code: 'CITY_SG_SIN',
      latitude: 1.347597342,
      longitude: 103.8516846,
    },
    {
      // IT.1UN6KQ5UK1RGX
      name: 'Kuala Lumpur',
      city_code: 'CITY_MY_KUL',
      latitude: 3.14711,
      longitude: 101.7056,
    },
    {
      // IT.0V1PXXFJ65KL8
      name: 'Ho Chi Minh',
      city_code: 'CITY_VN_SGN',
      latitude: 10.78595,
      longitude: 106.6928,
    },
    {
      // FI.C2.32c9c859d8332d4036ab3e575b415e40.IT_1SVF41LOW6S6K
      name: 'Manila',
      city_code: 'CITY_PH_MNL',
      latitude: 14.60126,
      longitude: 121.0212,
    },
    {
      // IT.070BEZTZ8U4NN
      name: 'Jakarta',
      city_code: 'CITY_ID_CGK',
      latitude: -6.208058364,
      longitude: 106.85141,
    },
    {
      // FI.C2.3dd52137c3d530403baa9a20ea0c5840.IT_2CGYZO82IAYOY
      name: 'Yangon',
      city_code: 'CITY_MM_RGN',
      latitude: 16.83501,
      longitude: 96.20179,
    },
    {
      // IT.2EOZSICUB69HN
      name: 'Hanoi',
      city_code: 'CITY_VN_HNI',
      latitude: 21.034136,
      longitude: 105.851447,
    },
    {
      // IT.179UR1E96UMBO
      name: 'Bangkok',
      city_code: 'CITY_TH_BKK',
      latitude: 13.74074,
      longitude: 100.51747,
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/cities.js
 **/